
// TODO 班主任售卖专属二维码
export default [
  {
    path: `/master-qrcode/order`,
    name: 'order',
    component: () => import(/* webpackChunkName: "order" */ '@/views/master-qrcode/order.vue')
  },
  {
    path: `/master-qrcode/error`,
    name: 'orderError',
    component: () => import(/* webpackChunkName: "error" */ '@/views/master-qrcode/error.vue')
  }
]
